<template>
  <div class="row">
    <div class="input-group col-lg-8" dir="ltr">
      <div class="input-group-prepend">
        <button class="btn btn-secondary" v-if="unFilteredFeatureTypes.indexOf(feature.type) === -1" type="button">
          <input v-model="item.filterable" type="checkbox"
                 class="align-middle">
        </button>
      </div>

      <date-picker v-if="feature.type==='date'" clearable auto-submit v-model="item.value"
                   placeholder="انتخاب تاریخ"
                   format="YYYY-MM-DD" display-format="jYYYY/jM/jD"/>

      <div v-else-if="feature.type=='formula'">
       <div class="mr-3">
         <input class="form-control" type="text" v-model="item.value" >

         <feature-search class="my-2" @selectedFeature="addVariable"/>
       </div>


      </div>

      <input dir="rtl" v-model="item.value" v-else type="text"
             class="form-control text-right">

      <div class="input-group-append">
        <button class="btn btn-secondary" @click="removeFeatureAttribute()" type="button">
          <b-icon icon="x"></b-icon>
        </button>
      </div>
    </div>
    <div class="col-lg-4" v-if="unFilteredFeatureTypes.indexOf(feature.type) === -1">
      <div id="featureImagePreview" class="my-2 text-center">
        <img alt="" v-if="item.featureImagePreview" width="300" height="300" :src="item.featureImagePreview"/>
      </div>

      <b-form-file
          browse-text="انتخاب عکس"
          @change="onFileChange"
          class="text-center"
          v-model="item.image"
          drop-placeholder="انتخاب عکس"
      ></b-form-file>

      <span class="btn btn-danger" v-if="imageStatus()" @click="removeAttributeImage()">حذف عکس </span>

      <input id="feature-image" type="hidden" @change="onFileChange"/>


    </div>
  </div>
</template>


<script>
import router from "@/router";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import {unFilteredFeatureTypes} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Feature'
import FeatureSearch from "@/plugin/components/dashboard/product/productFeatureComponents/FeatureSearch.vue";


export default {
  name: "FeatureAttribute",
  components: {datePicker: VuePersianDatetimePicker, FeatureSearch},
  data() {
    return {
      unFilteredFeatureTypes,
    }
  },
  props: {
    item: {},
    feature: {},
    featureIndex: {},
  },
  computed: {
    pageStatus() {
      // below condition define we are in update mode or not
      return router.currentRoute.params.id !== undefined
    },

  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      this.item.featureImage = file;
      this.item.featureImagePreview = URL.createObjectURL(file);
    },
    removeAttributeImage() {
      if (confirm('از حذف عکس اطمینان دارید؟')) {
        // in create mode we make image empty and in update mode we request to server to make it remove
        if (this.pageStatus) {
          this.$store.dispatch('Feature/removeFeatureAttributeImage', this.item).then(res => {
            this.item.featureImagePreview = '';
            this.item.image = [];
            this.item.featureImage = null
          })
        } else {
          this.item.featureImagePreview = '';
          this.item.image = [];
          this.item.featureImage = null
        }
      }
      this.$forceUpdate()
    },
    imageStatus() {
      return this.item.featureImagePreview != null
    },
    removeFeatureAttribute() {
      this.$emit('removeFeatureAttribute', this.featureIndex)
    },

    addVariable(value) {
      this.item.value += `f${value.feature_attributes[0].id}`
    }
  },
}
</script>

<style scoped>
#featureImagePreview img {
  width: 100px;
  height: 100px;
  object-fit: contain;
}
</style>